<div class='container'>
    <div class='min'>{{min}}</div>
    <mat-slider [disabled]="disabled" [max]="max" [min]="min" [(ngModel)]="model" (ngModelChange)="changeEvent(model)" [displayWith]="display"></mat-slider>
    <div class='max'>{{max}}</div>
</div>